import { IAnalyticsAdapter } from "./IAnalyticsAdapter";
import { ServiceType } from "../ServiceManager";
import { ClientWebsiteConfig } from "../Config";
import { AnalyticsEvent, AnalyticsEventType, AnalyticsPageView } from "./AnalyticsEvents";
import { Logger, LogLevel } from "../Logger";

class GoogleAnalyticsAdapter implements IAnalyticsAdapter {
    Type: ServiceType = ServiceType.Analytics;
    Id: string = 'GoogleAnalyticsAdapter';

    TrackerIds: string[] = [];
    GA: any;

    constructor(config: ClientWebsiteConfig) {
        var ga = this.InitGoogleAnalytics();        

        config.Settings?.Analytics.GoogleAnalyticsTrackingIds.forEach((id, idx) => {
            var trackerId = 'tracker_' + idx;

            this.TrackerIds.push(trackerId);

            ga('create', id, 'auto', trackerId);
            Logger.Log(LogLevel.Debug, '[Google Analytics]', `Initialised tracker ${id}`);
        });

        this.GA = ga;
    }

    InitGoogleAnalytics(): any {
        function initGa(i: any, s: any, o: any, g: any, r: any, a: any, m: any) {
            i["GoogleAnalyticsObject"] = r;

            i[r]=i[r] || function() {
                (i[r].q=i[r].q||[]).push(arguments)
            }

            i[r].l= new Date().getTime();

            a=s.createElement(o);

            m=s.getElementsByTagName(o)[0];

            a.async=1;
            a.src=g;
            
            m.parentNode.insertBefore(a,m);

            return i[r];
        }

        return initGa(window,document,'script','https://www.google-analytics.com/analytics.js','ga', null, null);
    }

    Record(event: AnalyticsEvent): void {
        Logger.Log(LogLevel.Debug, '[Google Analytics]', 'Sending event', event);

        const win = window as any;

        const ga: any = win[win["GoogleAnalyticsObject"]];

        switch(event.Type) {
            case AnalyticsEventType.PageView:

                const evt = event as AnalyticsPageView;

                this.TrackerIds.forEach(id => {
                  ga(`${id}.set`, {
                    page: evt.Page,
                    title: evt.Title
                  });

                  ga(`${id}.send`, 'pageview');
                });
                
                break;
            case AnalyticsEventType.ContactFormSubmit:

                this.TrackerIds.forEach(id => {
                  ga(`${id}.send`, 'event', 'Contact Form', 'Submit');
                });

                break;
        }
    }
}

export { GoogleAnalyticsAdapter }
